export const languageSet = [
  {
    language: 'English',
    code: 'en',
    rtl: '',
    status: 'Active',
  },
];
